import { render, staticRenderFns } from "./agreementDetial.vue?vue&type=template&id=558f1baa&scoped=true&"
import script from "./agreementDetial.vue?vue&type=script&lang=js&"
export * from "./agreementDetial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f1baa",
  null
  
)

export default component.exports